import {UserDashboardSettingsResponseBody} from '@dms/api/shared';

import {Nullish} from 'shared/web';

import {WORKSHOP_OVERVIEW_TILES} from '../constants/workshopOverviewTiles';

// True when at least one workshop-overview tile is enabled in the user's
// dashboard settings — gates whether the whole widget is shown.
export function hasEnabledWorkshopTiles(
  settings: UserDashboardSettingsResponseBody | Nullish
): boolean {
  return WORKSHOP_OVERVIEW_TILES.some((tile) => Boolean(settings?.[tile.settingsKey]));
}
